<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Hammedde Ekle/Güncelle</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">

      <div class="form-group">
        <label>Hammadde</label>

        <input type="text" formControlName="name" class="form-control">
      </div>

      <button (click)="search()" class="btn btn-danger">Cosing'den Çek</button>
     
      <table *ngIf="cosingResult" class="table table-bordered">
        <tr>
          <td>Inci Adı</td>
          <td>CAS</td>
          <td>EINECS</td>
          <td>Fonksiyon</td>
          <td>Seç</td>
        </tr>

        <tr *ngFor="let d of cosingResult.results">
          <td>{{d.metadata.inciName[0]}}</td>
          <td>{{d.metadata.casNo[0]}}</td>
          <td>{{d.metadata.ecNo[0]}}</td>
          <td>
            {{d.metadata.functionName.join(',')}}

          </td>
          <td>
            <button (click)="select(d)">Seç</button>

          </td>

        </tr>
      </table>

      <div class="form-group">
        <label>Cosing Id</label>

        <input type="text" formControlName="cosingId" class="form-control">
      </div>
      <div class="form-group">
        <label>INCI Adı</label>

        <input type="text" formControlName="inciName" class="form-control">
      </div>
      <div class="form-group">
        <label>CAS</label>

        <input type="text" formControlName="cas" class="form-control">
      </div>
      <div class="form-group">
        <label>EINECS/ELICS</label>

        <input type="text" formControlName="einecs" class="form-control">
      </div>
      <div class="form-group">
        <label>Fonksiyon</label>

        <input type="text" formControlName="function" class="form-control">
      </div>

      <div class="form-group">
        <label>noael</label>

        <input type="text" formControlName="noael" class="form-control">
      </div>

       <div class="form-group">
        <label>annex</label>

        <input type="text" formControlName="annex" class="form-control">
      </div>
      <div class="form-group">
        <label>references</label>
 <ngx-editor-menu [editor]="editor2a" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor2a" formControlName="references">
                            </ngx-editor>
       
      </div>
      <div class="form-group">
        <label>toksicology</label>
 <ngx-editor-menu [editor]="editor2b" [toolbar]="toolbar">
                            </ngx-editor-menu>
                            <ngx-editor [editor]="editor2b" formControlName="toksicology"  minheight="200">
                            </ngx-editor>
       
      </div>
    </div>

    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Kapat</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Kaydet</button>
    </div>
  </form>
</div>